import LocalizationEntity from "../../../../../domain/entities/localization.entity";

const ChangeLanguageApiImpl = (language: LocalizationEntity, keySave: string): void => {
    localStorage.setItem(keySave, language.code);
    //set language in the browser
    document.documentElement.lang = language.code;
}
export default ChangeLanguageApiImpl;